import { isSafeReturnUrl } from './paymentReturnUrl';

const HOME_PATH = '/home';

// `new URL()` cannot parse these on its own, so they reach the relative branch, but browsers
// resolve them against the current protocol and navigate off-site. Backslashes must be normalised
// first: the WHATWG URL parser treats `\\evil.com` and `\/evil.com` as protocol-relative too, and
// history.push() on a cross-origin result throws an uncaught SecurityError.
const isProtocolRelative = (value) => {
    return value.replace(/\\/g, '/').startsWith('//');
};

export const navigationResults = {
    EXTERNAL: 'external',
    INTERNAL: 'internal',
    FALLBACK: 'fallback',
};

const parseAbsoluteUrl = (value) => {
    try {
        return new URL(value);
    } catch (error) {
        return null;
    }
};

/**
 * Leaves onboarding for `returnUrl`: an allowlisted absolute URL becomes a real cross-origin
 * navigation, a relative path stays an in-app route, and anything else falls back to /home.
 *
 * @param {object} history react-router history
 * @param {string} returnUrl the raw `return` query param
 * @returns {'external'|'internal'|'fallback'} which branch ran
 */
export const navigateToReturnUrl = (history, returnUrl) => {
    const goHome = () => {
        if (history) {
            history.push(HOME_PATH);
        }
        return navigationResults.FALLBACK;
    };

    if (!returnUrl || typeof returnUrl !== 'string') {
        return goHome();
    }

    if (isProtocolRelative(returnUrl)) {
        return goHome();
    }

    if (parseAbsoluteUrl(returnUrl)) {
        if (!isSafeReturnUrl(returnUrl)) {
            return goHome();
        }
        window.location.href = returnUrl;
        return navigationResults.EXTERNAL;
    }

    if (!history) {
        return navigationResults.FALLBACK;
    }

    history.push(returnUrl);
    return navigationResults.INTERNAL;
};
